import React, { useState } from 'react'
import Menu from '../common/Menu/Menu'

import FooterThree from '../common/Footer/FooterThree';
import ElevatorLoader from '../Loder/ElevatorLoader';
import Greenbanner from './Greenbanner';
import GreenEnergyPage from './GreenEnergyPage';


const Greenenergy = () => {
    const [loading, setLoading] = useState(true);
    
  return (
    <div>
        {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
        <Menu header_style_2={true} />
        <Greenbanner />
        <GreenEnergyPage/>
        <FooterThree />

    </div>
  )
}

export default Greenenergy